import React from 'react'
import useInstallerAction, { installerRequest, isHostedEndpoint } from '../../../../features/installers/useInstallerAction'

const MESSAGE_CLASS = {
    success: 'text-success',
    info: 'text-muted',
    error: 'text-danger'
}
const InstallerAction = ({ connection, side, className }) => {
    const endpoint = connection[side]
    const isHosted = isHostedEndpoint(endpoint)
    const { start, isBusy, busyLabel, message } = useInstallerAction(installerRequest(connection, side), isHosted)

    return (
        <div className="installerAction">
            <button
                type="button"
                className={className || 'btn btn-primary btn-rounded waves-effect waves-light float-right new-connector'}
                disabled={isBusy}
                onClick={start}
            >
                {isBusy ? busyLabel : isHosted ? 'Start Setup' : 'Download'}
            </button>
            {message ? (
                <p className={`clearfix mb-0 pt-2 ${MESSAGE_CLASS[message.tone] || ''}`} role={message.tone === 'error' ? 'alert' : 'status'}>
                    {message.text}
                </p>
            ) : null}
        </div>
    )
}

export default InstallerAction
